import { Skeleton } from '@crehana/compass.ui/v3/skeleton';

export const LearningDashboardSkeleton = () => (
  <div className="tw-flex tw-flex-col tw-cds-gap-6">
    {/* Tabs bar skeleton */}
    <div className="tw-flex tw-cds-gap-5">
      <Skeleton.Block className="tw-w-20 tw-h-8" />
      <Skeleton.Block className="tw-w-24 tw-h-8" />
      <Skeleton.Block className="tw-w-24 tw-h-8" />
      <Skeleton.Block className="tw-w-28 tw-h-8" />
    </div>
    {/* Content card skeleton */}
    <Skeleton.Block className="tw-w-full tw-h-48" />
  </div>
);
